/**
 * Which members a search form state selects: pure helpers over the shared search form's `{plan, values}` state,
 * for a listing that must tell whether an applied search changed what it lists. No DOM, no store.
 */

const blank = (part) => part === null || part === undefined || part === '';

/**
 * Return the values that narrow a search: the form keeps a cleared filter as an empty list or a blank range,
 * which selects the same members as no value at all.
 *
 * :param values: The search form's values, keyed by value id.
 * :return: The same values without the empty ones.
 */
export function narrowingValues(values) {
    return Object.keys(values || {}).reduce((kept, id) => {
        const value = values[id];
        if (!(blank(value) || (Array.isArray(value) && value.every(blank)))) kept[id] = value;
        return kept;
    }, {});
}

/**
 * Compare two search states by the members they select: the same plan and the same narrowing values.
 *
 * :param a: A search state, or null.
 * :param b: A search state, or null.
 * :return: True when both select the same members.
 */
export function sameSearch(a, b) {
    if (!a || !b) return a === b;
    const selecting = (state) => JSON.stringify([state.plan, narrowingValues(state.values)]);
    return selecting(a) === selecting(b);
}
